export default '/home/acc13/public_html/swagger/node_modules/web-tree-sitter'